import React from 'react'
import { Layout } from 'antd'
import { SiteRoutes } from '../Route'

const { Content } = Layout

const SiteLayout = (props) => {
  const style = (props.location.pathname === '/') ? {padding: "0"} : {padding: "20px 0"};
  
  return (
    <Layout>
      <Content className="site-layout-content" style={style}>
        <SiteRoutes />
      </Content>
    </Layout>
  )
}

export default SiteLayout



// WEBPACK FOOTER //
// ./src/layout/SiteLayout.js